import React, { useEffect, useState } from 'react';
import { WaitlistForm } from './WaitlistForm';
export function CountdownCard() {
  const [timeLeft, setTimeLeft] = useState({
    days: 32,
    hours: 24,
    minutes: 7,
    seconds: 57
  });
  useEffect(() => {
    const targetDate = new Date().getTime() + 32 * 24 * 60 * 60 * 1000 + 24 * 60 * 60 * 1000 + 7 * 60 * 1000 + 57 * 1000;
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;
      if (distance < 0) {
        clearInterval(interval);
        return;
      }
      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const padZero = (num: number) => num.toString().padStart(2, '0');
  return <div className="relative z-10 w-[462px] h-[462px] md:w-[572px] md:h-[572px] mx-auto mt-8 md:mt-12" data-id="element-10">
      {/* Lottie Animation Background */}
      <iframe src="https://lottie.host/embed/5d013d8e-08ab-4d16-a469-db03ed081c3d/sIjoH29mug.lottie" className="absolute inset-0 w-full h-full border-none pointer-events-none" title="Lottie Blob Animation" data-id="element-11" />

      {/* Content Card - Positioned inside blob with padding */}
      <div className="absolute inset-0 flex items-center justify-center px-[48px] py-[48px] md:px-[60px] md:py-[60px]" data-id="element-12">
        <div className="bg-yellow-200/20 backdrop-blur-md rounded-3xl p-6 w-64 text-center border border-yellow-100/30" data-id="element-13">
          {/* Countdown Timer */}
          <div className="flex justify-center gap-3 mb-4" data-id="element-14">
            <div className="text-center" data-id="element-15">
              <div className="text-2xl font-bold text-gray-900" data-id="element-16">
                {padZero(timeLeft.days)}
              </div>
              <div className="text-xs text-gray-700" data-id="element-17">Days</div>
            </div>
            <div className="text-center" data-id="element-18">
              <div className="text-2xl font-bold text-gray-900" data-id="element-19">
                {padZero(timeLeft.hours)}
              </div>
              <div className="text-xs text-gray-700" data-id="element-20">Hours</div>
            </div>
            <div className="text-center" data-id="element-21">
              <div className="text-2xl font-bold text-gray-900" data-id="element-22">
                {padZero(timeLeft.minutes)}
              </div>
              <div className="text-xs text-gray-700" data-id="element-23">Mins</div>
            </div>
            <div className="text-center" data-id="element-24">
              <div className="text-2xl font-bold text-gray-900" data-id="element-25">
                {padZero(timeLeft.seconds)}
              </div>
              <div className="text-xs text-gray-700" data-id="element-26">Secs</div>
            </div>
          </div>

          {/* Email Form */}
          <div className="mb-4" data-id="element-27">
            <WaitlistForm data-id="element-28" />
          </div>

          {/* Social Proof */}
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-29">
            <div className="flex -space-x-2" data-id="element-30">
              <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=32&h=32&fit=crop&crop=face" alt="Cafe owner 1" className="w-6 h-6 rounded-full border-2 border-white" data-id="element-31" />
              <img src="https://images.unsplash.com/photo-1494790108755-2616b612b786?w=32&h=32&fit=crop&crop=face" alt="Cafe owner 2" className="w-6 h-6 rounded-full border-2 border-white" data-id="element-32" />
              <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=32&h=32&fit=crop&crop=face" alt="Cafe owner 3" className="w-6 h-6 rounded-full border-2 border-white" data-id="element-33" />
            </div>
            <span className="text-white font-semibold text-xs bg-gray-900 px-3 py-1.5 rounded-full shadow-md" data-id="element-34">
              First 10 cafés signing up now
            </span>
          </div>
        </div>
      </div>

      {/* Tagline below blob */}
      <p className="absolute -bottom-14 left-0 w-full text-center text-xl md:text-2xl font-bold tracking-tight whitespace-nowrap" data-id="element-35">
        <span className="text-gray-900" data-id="element-36">Zero Risk. Zero Investment.</span>{' '}
        <span className="text-amber-600" data-id="element-37">Join our Trial program.</span>
      </p>
    </div>;
}